/* eslint-disable eqeqeq,guard-for-in,no-restricted-syntax,@typescript-eslint/no-shadow,@typescript-eslint/no-unused-vars */

import { EVENTS } from '../../../../app/constants/events';

xplenty.controller('ComponentEditorWorkflowController', [
  '$scope',
  '$rootScope',
  '$timeout',
  '$controller',
  'modalService',
  'variables',

  function ($scope, $rootScope, $timeout, $controller, modalService, variablesServise) {
    angular.extend(this, $controller('WorkflowOperatorStep', { $scope }));

    let variables = angular.copy($scope.component.variables);
    let packageVariables = null;

    $scope.variables = angular.copy(variables);

    $scope.componentFormStep = $scope.$parent.createStep(
      'Package to run',
      'Choose a package',
      $scope.component.editorDirective,
    );
    $scope.packageVariablesStep = $scope.$parent.createStep(
      'Variables',
      'Edit variables',
      '<package-variables-editor class="packages-variables-workflow" disable-key="true" hide-footer="true" hide-add="true" use-package-default="true" variables-to-set="packageVariables" ng-model="variables" error="packageVariablesStep.error" valid="packageVariablesStep.valid"></package-variables-editor>',
    );

    $scope.packageOperatorStep.lock = false;
    $scope.packageOperatorStep.valid = !$scope.packageOperatorStep.lock;
    $scope.packageVariablesStep.valid = false;

    $scope.$watch(
      'package',
      function (newPackage, oldPackage) {
        if (newPackage === null && oldPackage !== null) {
          variables = {};
        }

        if (newPackage) {
          $scope.componentFormStep.tags = [
            {
              name: _.escape(newPackage.name),
            },
          ];
          if (!packageVariables) {
            packageVariables = angular.copy(newPackage.variables);
            $scope.packageVariables = angular.copy(newPackage.variables);
          }
          $scope.variables = { ...(newPackage.variables || {}), ...variables };
          $rootScope.$broadcast(EVENTS.JOB_VARIABLES_LOADED, $scope.variables);
          $scope.packageVariablesStep.lock = false;
          $scope.packageVariablesStep.valid = true;
          $scope.componentFormStep.valid = true;
          $scope.componentFormStep.active = true;
        } else {
          $scope.componentFormStep.active = true;
          $scope.componentFormStep.tags = [];
          $scope.packageVariablesStep.tags = [];
          $scope.packageVariablesStep.lock = true;
          $scope.packageVariablesStep.valid = false;
          $scope.componentFormStep.valid = false;
          $rootScope.$broadcast(EVENTS.JOB_VARIABLES_LOADED, {});
        }
      },
      true,
    );

    $scope.$watch(
      'variables',
      function (variables) {
        const diff = variablesServise.diffVariables(variables, packageVariables);
        $scope.component.variables = diff;
        $scope.packageVariablesStep.tags = [];
        for (const key in variables) {
          $scope.packageVariablesStep.tags.push({
            name: `<strong>${_.escape(key)}</strong>: ${_.escape(variables[key])}`,
          });
        }
      },
      true,
    );

    $scope.$watch('component.operator', function (operator) {
      if (operator == 'and') {
        $scope.packageOperatorStep.tags = [
          {
            name: 'all preceding conditions evaluate to true (AND)',
          },
        ];
      } else if (operator == 'or') {
        $scope.packageOperatorStep.tags = [
          {
            name: 'one of the preceding conditions evaluate to true (OR)',
          },
        ];
      } else {
        $scope.packageOperatorStep.tags = [];
      }
    });

    let componentNameValid = false;

    $rootScope.$on(EVENTS.DESIGNER_COMPONENT_NAME_VALID, function (event, valid) {
      componentNameValid = valid;
    });

    $scope.$watch(
      'component',
      function (component) {
        $timeout(function () {
          const saveDisabled = !(
            (
              componentNameValid &&
              $scope.componentFormStep.valid &&
              $scope.packageVariablesStep.valid
            ) /* && $scope.componentNameValid */
          );
          $rootScope.$broadcast(EVENTS.DESIGNER_COMPONENT_SAVE_DISABLE, saveDisabled);
        });
      },
      true,
    );
  },
]);
